// 本文テキスト中のURLをタップ可能なリンクに変換して表示する。
// おしらせ(orders_data.matter)はプレーンテキストのため、告知文に
// 「はじめてのセルフ利用ガイド」等のリンクを入れられるようにする（2026-09-01）。
// 自アプリ(now.laundrypack.app)へのリンクは同タブ遷移、外部は新規タブ。
import React from 'react';

const URL_RE = /(https?:\/\/[^\s、。」）)]+)/g;

export function LinkifyText({ text }) {
  const s = String(text ?? '');
  const parts = s.split(URL_RE);
  return (
    <>
      {parts.map((part, i) => {
        if (!/^https?:\/\//.test(part)) return <React.Fragment key={i}>{part}</React.Fragment>;
        const isInternal = part.startsWith('https://now.laundrypack.app');
        return (
          <a
            key={i}
            href={isInternal ? part.replace('https://now.laundrypack.app', '') : part}
            target={isInternal ? undefined : '_blank'}
            rel={isInternal ? undefined : 'noreferrer'}
            style={{ wordBreak: 'break-all' }}
          >
            {part}
          </a>
        );
      })}
    </>
  );
}
